import { forEach } from 'ramda'

export default {
  /**
   * Opens the lightbox.
   *
   * @param {Function} commit
   * @returns {Promise}
   */
  open({ commit }) {
    return commit('SET_OPEN', true)
  },

  /**
   * Closes the lightbox.
   *
   * @param {Function} commit
   * @returns {Promise}
   */
  close({ commit }) {
    return commit('SET_OPEN', false)
  },

  /**
   * Sets the images on the lightbox.
   *
   * @param {Function} commit
   * @param {String} src
   * @param {String} label
   * @returns {Promise}
   */
  addImage({ commit }, { src, label }) {
    return commit('ADD_IMAGE', { src, label })
  },

  /**
   * Adds multiple images to the lightbox.
   *
   * @param {Function} commit
   * @param {Array} images
   */
  addMultipleImages({ commit }, images) {
    forEach(({ src, label }) => commit('ADD_IMAGE', { src, label }), images)
  },

  /**
   * Clears all images from the lightbox.
   *
   * @param commit
   * @returns {*}
   */
  clearImages({ commit }) {
    return commit('SET_IMAGES', [])
  },
}
